import { render, staticRenderFns } from "./zhibozhonga.vue?vue&type=template&id=35ded712&scoped=true"
var script = {}
import style0 from "./zhibozhonga.vue?vue&type=style&index=0&id=35ded712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ded712",
  null
  
)

export default component.exports